import { Calendar, ShoppingBag } from 'lucide-react';
import {
  ModeFeatureCard,
  SelectableFeatureCard,
} from './AIConfigurationUI.tsx';
import type { ModeSelectOption } from './AIConfigurationUI.tsx';
import type { AIConfigurationStepId } from '../../configuration/steps.ts';
import type { LucideIcon } from 'lucide-react';

type CapabilityCard = {
  id: 'fulfillment' | 'reviews' | 'jobs';
  title: string;
  description: string;
  dependency: string;
  icon: LucideIcon;
};

type PedidoChecklistItem = {
  label: string;
  ok: boolean;
};

type CapabilitiesStepProps = {
  isAtendabotBrand: boolean;
  pedidosFeatureOn: boolean;
  reservasFeatureOn: boolean;
  modoPedidos: 'whatsapp' | 'link' | null;
  modoReservas: 'whatsapp' | 'link' | null;
  pedidosModeOptions: ModeSelectOption[];
  reservasModeOptions: ModeSelectOption[];
  visibleCapabilityCards: CapabilityCard[];
  fulfillmentForcado: boolean;
  fulfillmentCardOn: boolean;
  showFeedbackPedidos: boolean;
  vagasOn: boolean;
  fulfillmentDirty: boolean;
  reviewsDirty: boolean;
  jobsDirty: boolean;
  modoPedidosDirty: boolean;
  modoReservasDirty: boolean;
  errors: Record<string, string>;
  visibleSteps: Array<{ id: AIConfigurationStepId; title: string }>;
  pedidoChecklist: PedidoChecklistItem[];
  onTogglePedidos: () => void;
  onToggleReservas: () => void;
  onSelectModoPedidos: (id: string) => void;
  onSelectModoReservas: (id: string) => void;
  onToggleCapability: (id: 'fulfillment' | 'reviews' | 'jobs') => void;
};

const CapabilitiesStep = ({
  isAtendabotBrand,
  pedidosFeatureOn,
  reservasFeatureOn,
  modoPedidos,
  modoReservas,
  pedidosModeOptions,
  reservasModeOptions,
  visibleCapabilityCards,
  fulfillmentForcado,
  fulfillmentCardOn,
  showFeedbackPedidos,
  vagasOn,
  fulfillmentDirty,
  reviewsDirty,
  jobsDirty,
  modoPedidosDirty,
  modoReservasDirty,
  errors,
  visibleSteps,
  pedidoChecklist,
  onTogglePedidos,
  onToggleReservas,
  onSelectModoPedidos,
  onSelectModoReservas,
  onToggleCapability,
}: CapabilitiesStepProps) => (
  <div className="ai-capabilities-layout">
    <div className="ai-feature-grid">
      {!isAtendabotBrand && (
        <ModeFeatureCard
          title="Cardápio e pedidos"
          icon={ShoppingBag}
          offNote="Desligado: a IA não fala de cardápio nem de pedidos."
          question="Como a IA deve agir quando o cliente quiser pedir?"
          selected={pedidosFeatureOn}
          onToggle={onTogglePedidos}
          options={pedidosModeOptions}
          value={modoPedidos}
          onSelectMode={onSelectModoPedidos}
          error={errors.modo_pedidos}
          errorKey="modo_pedidos"
          dirty={modoPedidosDirty}
        />
      )}
      {!isAtendabotBrand && (
        <ModeFeatureCard
          title="Reservas"
          icon={Calendar}
          offNote="Desligado: a IA responde que o restaurante não trabalha com reservas."
          question="Como a IA deve agir quando o cliente quiser reservar?"
          selected={reservasFeatureOn}
          onToggle={onToggleReservas}
          options={reservasModeOptions}
          value={modoReservas}
          onSelectMode={onSelectModoReservas}
          error={errors.modo_reservas}
          errorKey="modo_reservas"
          dirty={modoReservasDirty}
        />
      )}
      {visibleCapabilityCards.map((item) => (
        <SelectableFeatureCard
          key={item.id}
          {...item}
          selected={
            item.id === 'fulfillment'
              ? fulfillmentForcado || fulfillmentCardOn
              : item.id === 'reviews'
                ? showFeedbackPedidos
                : vagasOn
          }
          locked={item.id === 'fulfillment' && fulfillmentForcado}
          lockedNote="Necessário porque a IA registra pedidos e precisa saber como o pedido chega ao cliente."
          onToggle={() => onToggleCapability(item.id)}
          dirty={
            item.id === 'fulfillment'
              ? fulfillmentDirty
              : item.id === 'reviews'
                ? reviewsDirty
                : jobsDirty
          }
        />
      ))}
    </div>
  </div>
);

export default CapabilitiesStep;
